import React, { useState, useEffect } from "react";
import { useWindowSize } from "react-use";
import styled from "styled-components";
import instance from "../../util/axios";
import { getQueryString } from "../../util/getQueryString";
import Designer, { ReportDef } from "./DesignerAnalysis";
import { Tabs, NavBar, Selector } from "antd-mobile-v5";


export interface transferItem {
    key?: string;
    uuid: string;
    tableName: string;
    name: string;
}

export const ReportNameWrapper = styled.div`

  .container {
    display:-webkit-box;
    white-space: nowrap; /* 防止内容换行 */
    overflow-x: scroll; /* 横向滚动 */
  }
  
  /* 隐藏默认的滚动条样式（可选） */
  .container::-webkit-scrollbar {
    display: none;
  }
`;

const id: string = getQueryString("id") || "";
let chartHeight: any = getQueryString("chartHeight");
if (chartHeight) {
    chartHeight = parseInt(chartHeight);
}
export default function Analysis() {
    const [data, setData] = useState<any[]>([]);
    const [thisData, setThisData] = useState<any>({});
    const [activateTab, setActivateTab] = useState<number>(0);
    const [activateSelect, setActivateSelect] = useState<number>(0);

    useEffect(() => {
        instance
            .get(`/oa/analysis/getDataList`)
            .then((resp) => {
                if (resp.data.Status === "1") {
                    const data = resp.data.Data;
                    console.log(data[0].children)
                    setData(data[0].children);
                    // const newData = {
                    //   uuid: data.uuid,
                    //   name: data.name,
                    //   statistiChartType: data.statistiChartType || "bar",
                    //   topFields: eval(data.topFields),
                    //   leftFields: eval(data.leftFields),
                    //   aggregateDefs: eval(data.aggregateDefs),
                    //   objectDefs: eval(data.objectDefs),
                    //   preDefinedFiltersForAggregate: eval(
                    //     data.preDefinedFiltersForAggregate
                    //   ),
                    //   preDefinedFiltersForReport: eval(data.preDefinedFiltersForReport),
                    //   joins: eval(data.joins),
                    //   filters: eval(data.filters),
                    //   reportFromRow: data.reportFromRow,
                    //   chartSort: data.chartSort,
                    //   sheetContent: eval(data.sheetContent),
                    // };
                    // setReportData(newData);
                    // setReportName(newData.name);
                    // setSelectedTables(newData.objectDefs);
                    // setFieldJoins(newData.joins);
                    // setChartHeight(data.statistiChartType === "map" ? 500 : 330);
                }
            });

    }, []);
    const onChangeNavbarTabs = (val: any) => {
        setActivateTab(val)
        setActivateSelect(0)
    };
    useEffect(() => {
        if (data&&data.length>1) {
            const info = data[activateTab].children[activateSelect];
            const newData = {
                uuid: info.uuid,
                name: info.name,
                statistiChartType: info.statistiChartType || "bar",
                topFields: eval(info.topFields),
                leftFields: eval(info.leftFields),
                aggregateDefs: eval(info.aggregateDefs),
                objectDefs: eval(info.objectDefs),
                preDefinedFiltersForAggregate: eval(
                    info.preDefinedFiltersForAggregate
                ),
                preDefinedFiltersForReport: eval(info.preDefinedFiltersForReport),
                joins: eval(info.joins),
                filters: eval(info.filters),
                reportFromRow: info.reportFromRow,
                chartSort: info.chartSort,
                sheetContent: eval(info.sheetContent),
            };
            setThisData(newData)
        }

    }, [activateSelect, activateTab,data])
    return (
        <ReportNameWrapper>
            <div style={{ background: "#ffffff", height: "100%" }}>
                <Tabs
                    activeLineMode="fixed"
                    defaultActiveKey="0"
                    onChange={onChangeNavbarTabs}
                >
                    {data && data.map((item, index: number) => {
                        if (Number(activateTab) === Number(index)) {
                            return (
                                <Tabs.Tab title={<span style={{ fontSize: "14px", fontWeight: 500 }}>{item.name}</span>} key={index} >
                                    <div className="container">
                                        {item.children.map((item1: any, index: number) => {
                                            return (
                                                <div
                                                    style={{
                                                        'borderRadius': '100px',
                                                        'border': 'solid transparent 1px',
                                                        // '--checked-border': 'solid var(--adm-color-primary) 1px',
                                                        padding: "4px",
                                                        fontSize: "12px",
                                                        background: "#f0f1fe",
                                                        marginRight: "6px",
                                                        color: activateSelect === index ? "#3F5FEB" : "",
                                                    }}
                                                    onClick={() => {
                                                        setActivateSelect(index)
                                                    }}
                                                >{item1.name}</div>
                                            )
                                        })}
                                    </div>
                                    <div style={{marginTop:"9px"}}>
                                        <Designer
                                            selectedObject={JSON.parse(item.children[activateSelect].objectDefs)}
                                            fieldJoins={JSON.parse(item.children[activateSelect].joins)}
                                            defaultReportData={thisData}
                                            name={item.children[activateSelect].name}
                                            showReport={undefined}
                                            showStatisticalChart={"1"}
                                            chartHeight={chartHeight}
                                            isApp={"true"}
                                            id={item.children[activateSelect].uuid}
                                        />
                                    </div>
                                </Tabs.Tab>
                            );
                        } else {
                            return (
                                <Tabs.Tab title={<span style={{ fontSize: "14px", }}>{item.name}</span>} key={index} >
                                   
                                </Tabs.Tab>
                            );
                        }
                    })}
                </Tabs>
            </div>
        </ReportNameWrapper>
    );
}
